import {
  Button,
  Grid,
  Typography,
} from '@material-ui/core';
import {
  Help,
} from '@material-ui/icons';
import React, { Fragment } from 'react';
import { useStepsStyles } from '../useStepsStyles';

export function ConstructEvidenceComponent({
  meter,
  sponsor,
}) {
  const classes = useStepsStyles(meter);

  const hasSufficientReadings =
    meter.readings.filter((r) => !r.deleted).length >= 3;

  return (
    <Grid container direction="column" spacing={1}>
      <Fragment>
        <Grid container direction="row">
          <Typography>Turn in your final project, get credit for your effort, and influence how others in your community save.</Typography>
        </Grid>
        <Grid container direction="row">
          <Button
            className={classes.root}
            color="primary"
            variant="outlined"
            component="a"
            href="https://meterhero.com/communicate"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Help - Communicate (opens in new window)"
          >
            <Help style={{ color: 'white' }} />
          </Button>
          {(sponsor && sponsor.finalProjectUrl) ? <Button
            className={classes.root}
            color="primary"
            variant="outlined"
            component="a"
            href={sponsor.finalProjectUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Submit your final project (opens in new window)"
          >
            Upload project
          </Button> : null}

          {(sponsor && sponsor.prePostSurveyUrl) ? <Button
            className={classes.root}
            color="primary"
            variant="outlined"
            component="a"
            href={sponsor.prePostSurveyUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Submit your pre/post survey (opens in new window)"
          >
            Post-Survey
          </Button> : null}
        </Grid>
      </Fragment>
    </Grid>
  );
}
